import LogoLong from '../../assets/icons/logoLong.svg?react';
import styled from 'styled-components';

const StyledLink = styled.a`
  display: inline-flex;
  text-decoration: none;
  height: 2.25rem;
  justify-content: center;
  align-items: center;
`;

export function LongLogoLink() {
  return (
    <StyledLink href="https://www.withtandem.com">
      <LogoLong title="tandem" />
    </StyledLink>
  );
}
